module.exports = __webpack_public_path__ + "5b7edd1c7171931a98b8574562abe447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/dome.png
// module id = 1643
// module chunks = 5